<div class="d-flex ps-3 py-2 align-items-center header">
    <fa-icon class="me-2" [icon]="faInfoCircle" aria-hidden="true"></fa-icon>
    <div
        class="my-3 ms-1 me-2 cursor-pointer"
        translate="SIDEMENU_SECTION_PACE_INFORMATION_LABEL"
        (click)="toggleIsCollapsed()"
    ></div>
    <div class="col-1 my-3 ms-0 me-2 cursor-pointer" (click)="toggleIsCollapsed()">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
</div>

@if (!isCollapsed) {
    <div class="pace-information-container" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        <table class="table table-condensed borderless">
            <tbody>
                @if (!isPaceOnlineUser) {
                    <tr>
                        <th translate="FREQUENT_ACTIVITIES_FOOTER_LAST_SYNC"></th>
                        <td>{{ getLastSync() }}</td>
                    </tr>
                }
                <tr>
                    <th translate="FREQUENT_ACTIVITIES_FOOTER_ENVIRONMENT"></th>
                    <td>{{ strings.environment }}</td>
                </tr>
                @if (!isPaceOnlineUser) {
                    <tr>
                        <th translate="FREQUENT_ACTIVITIES_FOOTER_BACKEND"></th>
                        <td>{{ strings.targetBackend }}</td>
                    </tr>
                }
                <tr>
                    <th>GID</th>
                    <td>{{ strings.gid }}</td>
                </tr>
                <tr>
                    <th translate="FREQUENT_ACTIVITIES_FOOTER_SALESORG"></th>
                    <td>{{ strings.salesOrg }}</td>
                </tr>
                <tr>
                    <th translate="FREQUENT_ACTIVITIES_FOOTER_PLANT"></th>
                    <td>{{ strings.plant }}</td>
                </tr>
                <tr>
                    <th translate="FREQUENT_ACTIVITIES_FOOTER_DESCRIPTION"></th>
                    <td>{{ strings.plantSalesOrgDescription }}</td>
                </tr>
                <tr>
                    <th translate="FREQUENT_ACTIVITIES_FOOTER_APP_VERSION"></th>
                    <td (click)="checkForUpdates()">{{ strings.appVersion }}</td>
                </tr>
                <tr>
                    <th translate="FREQUENT_ACTIVITIES_FOOTER_DEVICE_ID"></th>
                    <td>
                        {{ strings.deviceId }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="d-flex justify-content-end gap-1 align-items-start pl-2">
            <button
                class="btn btn-primary d-flex gap-2 flex-column"
                type="button"
                (click)="releaseLock()"
                [disabled]="(isOnline$ | async) === false"
            >
                <fa-icon [icon]="(isOnline$ | async) ? faDesktop : faBan"></fa-icon>
                <span>{{ 'DEVICE_LOCK_BUTTON' | translate }}</span>
            </button>
            <button class="btn btn-primary d-flex gap-2 flex-column" type="button" (click)="openChangelog()">
                <fa-icon [icon]="faCodeBranch"></fa-icon>
                <span>{{ 'SIDEMENU_BUTTON_CHANGELOG_LABEL' | translate }}</span>
            </button>
            <button class="btn btn-primary d-flex gap-2 flex-column" type="button" (click)="openPaceSpector()">
                <fa-icon [icon]="faToolbox"></fa-icon>
                <span>{{ 'TIMESHEET_INSPECT_BUTTON' | translate }}</span>
            </button>
        </div>
    </div>
}
